"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var utilities_1 = require("../../../utilities/utilities");
var MessageBlock_1 = tslib_1.__importStar(require("../../components/MessageBlock"));
var PrivateContentBoundary = function (_a) {
    var renderEmpty = _a.renderEmpty;
    return (react_1["default"].createElement(MessageBlock_1["default"], { color: "danger" },
        utilities_1.__('Zamknutý obsah'),
        !!renderEmpty && (react_1["default"].createElement(MessageBlock_1.Description, null, utilities_1.__('Za touto hranicou nasleduje zamknutý obsah')))));
};
exports["default"] = PrivateContentBoundary;
